const tokens = {
  "colors.transparent": {
    "value": "transparent",
    "variable": "var(--edNtiq)"
  },
  "colors.common.white": {
    "value": "#ffffff",
    "variable": "var(--hLWWtf)"
  },
  "colors.common.black": {
    "value": "#000",
    "variable": "var(--byTFlv)"
  },
  "colors.grey.100": {
    "value": "#f7f7f7",
    "variable": "var(--fNYchh)"
  },
  "colors.grey.200": {
    "value": "#D8D9DA",
    "variable": "var(--emjLIy)"
  },
  "colors.grey.300": {
    "value": "#B1B3B5",
    "variable": "var(--cKYgGX)"
  },
  "colors.grey.400": {
    "value": "#8B8C8F",
    "variable": "var(--iTUtbY)"
  },
  "colors.grey.500": {
    "value": "#64666A",
    "variable": "var(--hsIOax)"
  },
  "colors.grey.800": {
    "value": "#262626",
    "variable": "var(--gIWTTM)"
  },
  "colors.blues.main": {
    "value": "#005FB9",
    "variable": "var(--gfcOTj)"
  },
  "colors.blues.dark": {
    "value": "#02427E",
    "variable": "var(--jErUoc)"
  },
  "colors.blues.darkest": {
    "value": "#02143A",
    "variable": "var(--dMvghm)"
  },
  "colors.blues.light": {
    "value": "#54A0E8",
    "variable": "var(--ciDhEq)"
  },
  "colors.blues.light-2": {
    "value": "#4B99E6",
    "variable": "var(--icJwtl)"
  },
  "colors.blues.lighter": {
    "value": "#9DCDFA",
    "variable": "var(--hbRtpt)"
  },
  "colors.blues.lighter-2": {
    "value": "#C8E4FE",
    "variable": "var(--jtDsZu)"
  },
  "colors.blues.lightest": {
    "value": "#EEF7FF",
    "variable": "var(--jbOUfw)"
  },
  "colors.blues.extraLight": {
    "value": "#DEEFFF",
    "variable": "var(--btoXRw)"
  },
  "colors.greens.main": {
    "value": "#008254",
    "variable": "var(--cxQyJm)"
  },
  "colors.greens.extraLight": {
    "value": "#EFFCF8",
    "variable": "var(--ixjwdl)"
  },
  "colors.greens.light": {
    "value": "#E3FAF2",
    "variable": "var(--hcePfP)"
  },
  "colors.greens.lighter": {
    "value": "#B7ECDA",
    "variable": "var(--hWNcfM)"
  },
  "colors.greens.lighter-2": {
    "value": "#81D6B8",
    "variable": "var(--kBRnif)"
  },
  "colors.greens.dark": {
    "value": "#006642",
    "variable": "var(--eVylkN)"
  },
  "colors.greens.lightest": {
    "value": "#E3FAF2",
    "variable": "var(--jtUyKp)"
  },
  "colors.greens.darkest": {
    "value": "#00482F",
    "variable": "var(--fYqhmD)"
  },
  "colors.nwGreens.main": {
    "value": "#8ccb32",
    "variable": "var(--hsiYqX)"
  },
  "colors.nwGreens.light": {
    "value": "#40AD87",
    "variable": "var(--rXuva)"
  },
  "colors.nwGreens.tintLP": {
    "value": "#A8EA4C",
    "variable": "var(--laZndv)"
  },
  "colors.reds.main": {
    "value": "#DE2828",
    "variable": "var(--dRjYcy)"
  },
  "colors.reds.dark": {
    "value": "#B40000",
    "variable": "var(--dmYUbd)"
  },
  "colors.reds.darker": {
    "value": "#7A0000",
    "variable": "var(--kqLHPC)"
  },
  "colors.reds.light": {
    "value": "#FF5D5E",
    "variable": "var(--fTAmLX)"
  },
  "colors.reds.lighter": {
    "value": "#FF9090",
    "variable": "var(--dlrtvo)"
  },
  "colors.reds.lighter-2": {
    "value": "#FFBFBF",
    "variable": "var(--dWSOyD)"
  },
  "colors.reds.lightest": {
    "value": "#FFE8E8",
    "variable": "var(--hJBbJR)"
  },
  "colors.reds.extraLight": {
    "value": "#FFF7F7",
    "variable": "var(--kwpXld)"
  },
  "colors.yellows.main": {
    "value": "#FFC764",
    "variable": "var(--cUliQp)"
  },
  "colors.yellows.dark": {
    "value": "#EFA92E",
    "variable": "var(--gWidpe)"
  },
  "colors.yellows.darkest": {
    "value": "#B07000",
    "variable": "var(--kJoPMA)"
  },
  "colors.yellows.light": {
    "value": "#FBD083",
    "variable": "var(--dFLMDE)"
  },
  "colors.yellows.lighter": {
    "value": "#FFE2AE",
    "variable": "var(--lhzVfb)"
  },
  "colors.yellows.lighter-2": {
    "value": "#FFF0D6",
    "variable": "var(--hZbRCk)"
  },
  "colors.yellows.lightest": {
    "value": "#FFF7EA",
    "variable": "var(--hDSNnS)"
  },
  "colors.yellows.extraLight": {
    "value": "#FFFBF4",
    "variable": "var(--gWxPDK)"
  },
  "colors.neutral.lightest": {
    "value": "#F5F5F5",
    "variable": "var(--cjsNgA)"
  },
  "colors.neutral.lighter": {
    "value": "#D8D9DA",
    "variable": "var(--bEUJZR)"
  },
  "colors.neutral.lighter-2": {
    "value": "#EBEBEC",
    "variable": "var(--llakQa)"
  },
  "colors.neutral.light": {
    "value": "#B1B3B5",
    "variable": "var(--dMWrki)"
  },
  "colors.neutral.main": {
    "value": "#8B8C8F",
    "variable": "var(--kJzGBz)"
  },
  "colors.neutral.dark": {
    "value": "#64666A",
    "variable": "var(--bBIdhM)"
  },
  "colors.neutral.darker": {
    "value": "#3D4045",
    "variable": "var(--cUIYef)"
  },
  "colors.bone.main": {
    "value": "#F4EEE6",
    "variable": "var(--fhhxDs)"
  },
  "colors.browns.main": {
    "value": "#B96C4F",
    "variable": "var(--caOtVz)"
  },
  "colors.browns.light": {
    "value": "#D58B70",
    "variable": "var(--lhlZhK)"
  },
  "colors.browns.lighter": {
    "value": "#EDBEAD",
    "variable": "var(--eHAypR)"
  },
  "colors.browns.lighter-2": {
    "value": "#FFEAE2",
    "variable": "var(--kyaAoq)"
  },
  "colors.browns.lighter-3": {
    "value": "#FEF4F1",
    "variable": "var(--krkMVD)"
  },
  "colors.browns.lighter-4": {
    "value": "#FFFAF9",
    "variable": "var(--gTjxFs)"
  },
  "colors.browns.dark": {
    "value": "#91472B",
    "variable": "var(--heIgqc)"
  },
  "colors.browns.darkest": {
    "value": "#652812",
    "variable": "var(--cheYzm)"
  },
  "colors.lime.main": {
    "value": "#E2FF39",
    "variable": "var(--irknoL)"
  },
  "colors.lime.tintLP": {
    "value": "#DDFA88",
    "variable": "var(--ivjiZb)"
  },
  "colors.lime.tintLP2": {
    "value": "#E8FDAC",
    "variable": "var(--hHEXZJ)"
  },
  "colors.lime.lightest": {
    "value": "#F8FFE4",
    "variable": "var(--ezSDgY)"
  },
  "spacing.0": {
    "value": "0rem",
    "variable": "var(--fcTUxn)"
  },
  "spacing.1": {
    "value": "0.25rem",
    "variable": "var(--dacYEG)"
  },
  "spacing.2": {
    "value": "0.5rem",
    "variable": "var(--ebuyxV)"
  },
  "spacing.3": {
    "value": "1rem",
    "variable": "var(--bYDCFo)"
  },
  "spacing.4": {
    "value": "1.75rem",
    "variable": "var(--hIimNX)"
  },
  "spacing.5": {
    "value": "2.75rem",
    "variable": "var(--fFrqVq)"
  },
  "spacing.6": {
    "value": "3rem",
    "variable": "var(--gGIQOF)"
  },
  "spacing.7": {
    "value": "3.5rem",
    "variable": "var(--eDRUVY)"
  },
  "spacing.8": {
    "value": "4rem",
    "variable": "var(--flZesP)"
  },
  "spacing.9": {
    "value": "4.5rem",
    "variable": "var(--djiiAi)"
  },
  "spacing.10": {
    "value": "5rem",
    "variable": "var(--ieMJEa)"
  },
  "spacing.12": {
    "value": "6rem",
    "variable": "var(--uyqLg)"
  },
  "spacing.16": {
    "value": "8rem",
    "variable": "var(--mYCWo)"
  },
  "spacing.20": {
    "value": "10rem",
    "variable": "var(--jgejxp)"
  },
  "spacing.24": {
    "value": "12rem",
    "variable": "var(--iYEvIx)"
  },
  "spacing.3.5": {
    "value": "1.5rem",
    "variable": "var(--dhUgfD)"
  },
  "spacing.content.0": {
    "value": "var(--fcTUxn)",
    "variable": "var(--iRIfcL)"
  },
  "spacing.content.1": {
    "value": "var(--dacYEG)",
    "variable": "var(--eOoFlW)"
  },
  "spacing.content.2": {
    "value": "var(--ebuyxV)",
    "variable": "var(--iwSGF)"
  },
  "spacing.content.3": {
    "value": "var(--bYDCFo)",
    "variable": "var(--huzcoM)"
  },
  "spacing.content.4": {
    "value": "var(--hIimNX)",
    "variable": "var(--gAAjJT)"
  },
  "spacing.content.5": {
    "value": "var(--fFrqVq)",
    "variable": "var(--cxgJTe)"
  },
  "spacing.content.3-half": {
    "value": "var(--dhUgfD)",
    "variable": "var(--fSriqq)"
  },
  "spacing.content.0--wide": {
    "value": "var(--fcTUxn)",
    "variable": "var(--hyrEA)"
  },
  "spacing.content.1--wide": {
    "value": "var(--dacYEG)",
    "variable": "var(--ekRRvp)"
  },
  "spacing.content.2--wide": {
    "value": "var(--ebuyxV)",
    "variable": "var(--iQJEaG)"
  },
  "spacing.content.3--wide": {
    "value": "var(--bYDCFo)",
    "variable": "var(--bEHusz)"
  },
  "spacing.content.3-half--wide": {
    "value": "var(--dhUgfD)",
    "variable": "var(--foBLxZ)"
  },
  "spacing.content.4--wide": {
    "value": "var(--hIimNX)",
    "variable": "var(--cyGmXs)"
  },
  "spacing.content.5--wide": {
    "value": "var(--fFrqVq)",
    "variable": "var(--gBZMOh)"
  },
  "fonts.gotham": {
    "value": "var(--font-gotham, Gotham), sans-serif",
    "variable": "var(--fYpfqa)"
  },
  "fonts.gothamDisplay": {
    "value": "var(--font-gotham, GothamDisplay), sans-serif",
    "variable": "var(--iYqLBE)"
  },
  "fonts.chronicleDisplay": {
    "value": "var(--font-chronicle-display, Chronicle Display), serif",
    "variable": "var(--jhkAvf)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--dbrZvb)"
  },
  "radii.xs": {
    "value": "0.125rem",
    "variable": "var(--ixNmpi)"
  },
  "radii.sm": {
    "value": "0.25rem",
    "variable": "var(--bewZvn)"
  },
  "radii.md": {
    "value": "0.5rem",
    "variable": "var(--kLOfAE)"
  },
  "radii.lg": {
    "value": "1rem",
    "variable": "var(--dxfumK)"
  },
  "radii.xl": {
    "value": "1.75rem",
    "variable": "var(--UXfgJ)"
  },
  "radii.2xl": {
    "value": "4rem",
    "variable": "var(--bphCwb)"
  },
  "radii.half": {
    "value": "50%",
    "variable": "var(--fHsYBa)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--kkkBVq)"
  },
  "shadows.tooltip": {
    "value": "0 4px 8px 0 rgb(100 102 106 / 15%), 0 8px 16px 0 rgb(100 102 106 / 33%)",
    "variable": "var(--eiGVpm)"
  },
  "shadows.popover": {
    "value": "rgba(100, 102, 106, 0.1) 0px 4px 8px 0px, rgba(100, 102, 106, 0.36) 0px 1px 4px 0px",
    "variable": "var(--bJjNhG)"
  },
  "shadows.dialog": {
    "value": "0px -4px 4px 0px #00000026",
    "variable": "var(--iJwbhz)"
  },
  "shadows.subnav": {
    "value": "0px 3px 10px 0px #0000000D",
    "variable": "var(--fVzHea)"
  },
  "shadows.dropdown": {
    "value": "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    "variable": "var(--jSfTlA)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--ghWdwL)"
  },
  "breakpoints.sm": {
    "value": "768px",
    "variable": "var(--ikokJA)"
  },
  "breakpoints.md": {
    "value": "1080px",
    "variable": "var(--kSvAmr)"
  },
  "breakpoints.lg": {
    "value": "1280px",
    "variable": "var(--uwdhN)"
  },
  "breakpoints.xl": {
    "value": "1440px",
    "variable": "var(--eyfDzy)"
  },
  "breakpoints.xxl": {
    "value": "1576px",
    "variable": "var(--dymagS)"
  },
  "breakpoints.xs_legacy": {
    "value": "0px",
    "variable": "var(--bHFVdD)"
  },
  "breakpoints.sm_legacy": {
    "value": "600px",
    "variable": "var(--dPZTNa)"
  },
  "breakpoints.md_legacy": {
    "value": "900px",
    "variable": "var(--hcHKhF)"
  },
  "breakpoints.lg_legacy": {
    "value": "1200px",
    "variable": "var(--ifDdUH)"
  },
  "breakpoints.xl_legacy": {
    "value": "1536px",
    "variable": "var(--bUvOIU)"
  },
  "sizes.breakpoint-sm": {
    "value": "768px",
    "variable": "var(--eomHOU)"
  },
  "sizes.breakpoint-md": {
    "value": "1080px",
    "variable": "var(--iujnmj)"
  },
  "sizes.breakpoint-lg": {
    "value": "1280px",
    "variable": "var(--gThSgZ)"
  },
  "sizes.breakpoint-xl": {
    "value": "1440px",
    "variable": "var(--cssArG)"
  },
  "sizes.breakpoint-xxl": {
    "value": "1576px",
    "variable": "var(--bfIHqC)"
  },
  "sizes.breakpoint-xs_legacy": {
    "value": "0px",
    "variable": "var(--jaMHAP)"
  },
  "sizes.breakpoint-sm_legacy": {
    "value": "600px",
    "variable": "var(--cenZIC)"
  },
  "sizes.breakpoint-md_legacy": {
    "value": "900px",
    "variable": "var(--fJPNtx)"
  },
  "sizes.breakpoint-lg_legacy": {
    "value": "1200px",
    "variable": "var(--gDOrcj)"
  },
  "sizes.breakpoint-xl_legacy": {
    "value": "1536px",
    "variable": "var(--hbZZNc)"
  },
  "colors.text.primary": {
    "value": "var(--byTFlv)",
    "variable": "var(--iagzVE)"
  },
  "colors.text.secondary": {
    "value": "var(--hsIOax)",
    "variable": "var(--YyYdq)"
  },
  "colors.primary.dark": {
    "value": "var(--eVylkN)",
    "variable": "var(--eaibXx)"
  },
  "colors.primary.main": {
    "value": "var(--cxQyJm)",
    "variable": "var(--UYacK)"
  },
  "colors.primary.light": {
    "value": "var(--rXuva)",
    "variable": "var(--bZesqz)"
  },
  "colors.secondary.light": {
    "value": "var(--jbOUfw)",
    "variable": "var(--eMkVoh)"
  },
  "colors.secondary.main": {
    "value": "var(--gfcOTj)",
    "variable": "var(--boMVTM)"
  },
  "colors.background.default": {
    "value": "var(--hLWWtf)",
    "variable": "var(--bAAdyE)"
  },
  "colors.background.paper": {
    "value": "var(--hLWWtf)",
    "variable": "var(--csYFXp)"
  },
  "colors.info.light": {
    "value": "var(--hDSNnS)",
    "variable": "var(--hAEReB)"
  },
  "colors.info.dark": {
    "value": "var(--gWidpe)",
    "variable": "var(--hqiGMb)"
  },
  "colors.info.main": {
    "value": "var(--dFLMDE)",
    "variable": "var(--eUHjmo)"
  },
  "colors.action.active": {
    "value": "rgba(0, 0, 0, 0.54)",
    "variable": "var(--kntPWP)"
  },
  "colors.action.hover": {
    "value": "rgba(0,0,0,0.04)",
    "variable": "var(--bxXrSt)"
  },
  "colors.action.disabled": {
    "value": "rgba(0, 0, 0, 0.26)",
    "variable": "var(--jwHfUD)"
  },
  "colors.action.disabledBackground": {
    "value": "rgba(0, 0, 0, 0.12)",
    "variable": "var(--dqiMeB)"
  },
  "colors.formControl.trim": {
    "value": "#b4b9c1",
    "variable": "var(--rHMxm)"
  },
  "colors.divider": {
    "value": "rgba(0, 0, 0, 0.12)",
    "variable": "var(--dnvhFR)"
  },
  "colors.logo.green": {
    "value": "#00AE4D",
    "variable": "var(--chACMJ)"
  },
  "colors.logo.greenDark": {
    "value": "#00682C",
    "variable": "var(--cjuKPt)"
  },
  "colors.logo.greenLight": {
    "value": "#8DC63F",
    "variable": "var(--eCaJav)"
  },
  "sizes.icon.small": {
    "value": "1rem",
    "variable": "var(--fNPLHd)"
  },
  "sizes.icon.medium": {
    "value": "1.5rem",
    "variable": "var(--kRZCmv)"
  },
  "sizes.icon.large": {
    "value": "2rem",
    "variable": "var(--cgpdYn)"
  },
  "sizes.icon.xLarge": {
    "value": "2.75rem",
    "variable": "var(--iAAfEv)"
  },
  "sizes.icon.xxLarge": {
    "value": "3.5rem",
    "variable": "var(--gvKnLX)"
  },
  "spacing.-1": {
    "value": "calc(var(--dacYEG) * -1)",
    "variable": "var(--dacYEG)"
  },
  "spacing.-2": {
    "value": "calc(var(--ebuyxV) * -1)",
    "variable": "var(--ebuyxV)"
  },
  "spacing.-3": {
    "value": "calc(var(--bYDCFo) * -1)",
    "variable": "var(--bYDCFo)"
  },
  "spacing.-4": {
    "value": "calc(var(--hIimNX) * -1)",
    "variable": "var(--hIimNX)"
  },
  "spacing.-5": {
    "value": "calc(var(--fFrqVq) * -1)",
    "variable": "var(--fFrqVq)"
  },
  "spacing.-6": {
    "value": "calc(var(--gGIQOF) * -1)",
    "variable": "var(--gGIQOF)"
  },
  "spacing.-7": {
    "value": "calc(var(--eDRUVY) * -1)",
    "variable": "var(--eDRUVY)"
  },
  "spacing.-8": {
    "value": "calc(var(--flZesP) * -1)",
    "variable": "var(--flZesP)"
  },
  "spacing.-9": {
    "value": "calc(var(--djiiAi) * -1)",
    "variable": "var(--djiiAi)"
  },
  "spacing.-10": {
    "value": "calc(var(--ieMJEa) * -1)",
    "variable": "var(--ieMJEa)"
  },
  "spacing.-12": {
    "value": "calc(var(--uyqLg) * -1)",
    "variable": "var(--uyqLg)"
  },
  "spacing.-16": {
    "value": "calc(var(--mYCWo) * -1)",
    "variable": "var(--mYCWo)"
  },
  "spacing.-20": {
    "value": "calc(var(--jgejxp) * -1)",
    "variable": "var(--jgejxp)"
  },
  "spacing.-24": {
    "value": "calc(var(--iYEvIx) * -1)",
    "variable": "var(--iYEvIx)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--dhUgfD) * -1)",
    "variable": "var(--dhUgfD)"
  },
  "spacing.content.-0": {
    "value": "calc(var(--iRIfcL) * -1)",
    "variable": "var(--iRIfcL)"
  },
  "spacing.content.-1": {
    "value": "calc(var(--eOoFlW) * -1)",
    "variable": "var(--eOoFlW)"
  },
  "spacing.content.-2": {
    "value": "calc(var(--iwSGF) * -1)",
    "variable": "var(--iwSGF)"
  },
  "spacing.content.-3": {
    "value": "calc(var(--huzcoM) * -1)",
    "variable": "var(--huzcoM)"
  },
  "spacing.content.-4": {
    "value": "calc(var(--gAAjJT) * -1)",
    "variable": "var(--gAAjJT)"
  },
  "spacing.content.-5": {
    "value": "calc(var(--cxgJTe) * -1)",
    "variable": "var(--cxgJTe)"
  },
  "spacing.content.-3-half": {
    "value": "calc(var(--fSriqq) * -1)",
    "variable": "var(--fSriqq)"
  },
  "spacing.content.-0--wide": {
    "value": "calc(var(--hyrEA) * -1)",
    "variable": "var(--hyrEA)"
  },
  "spacing.content.-1--wide": {
    "value": "calc(var(--ekRRvp) * -1)",
    "variable": "var(--ekRRvp)"
  },
  "spacing.content.-2--wide": {
    "value": "calc(var(--iQJEaG) * -1)",
    "variable": "var(--iQJEaG)"
  },
  "spacing.content.-3--wide": {
    "value": "calc(var(--bEHusz) * -1)",
    "variable": "var(--bEHusz)"
  },
  "spacing.content.-3-half--wide": {
    "value": "calc(var(--foBLxZ) * -1)",
    "variable": "var(--foBLxZ)"
  },
  "spacing.content.-4--wide": {
    "value": "calc(var(--cyGmXs) * -1)",
    "variable": "var(--cyGmXs)"
  },
  "spacing.content.-5--wide": {
    "value": "calc(var(--gBZMOh) * -1)",
    "variable": "var(--gBZMOh)"
  },
  "colors.colorPalette": {
    "value": "var(--idUrcU)",
    "variable": "var(--idUrcU)"
  },
  "colors.colorPalette.white": {
    "value": "var(--kwEEJq)",
    "variable": "var(--kwEEJq)"
  },
  "colors.colorPalette.black": {
    "value": "var(--lfOvJa)",
    "variable": "var(--lfOvJa)"
  },
  "colors.colorPalette.100": {
    "value": "var(--iSScQY)",
    "variable": "var(--iSScQY)"
  },
  "colors.colorPalette.200": {
    "value": "var(--bdPmBD)",
    "variable": "var(--bdPmBD)"
  },
  "colors.colorPalette.300": {
    "value": "var(--EuecW)",
    "variable": "var(--EuecW)"
  },
  "colors.colorPalette.400": {
    "value": "var(--dIdJaV)",
    "variable": "var(--dIdJaV)"
  },
  "colors.colorPalette.500": {
    "value": "var(--iOGEjQ)",
    "variable": "var(--iOGEjQ)"
  },
  "colors.colorPalette.800": {
    "value": "var(--iCIPjV)",
    "variable": "var(--iCIPjV)"
  },
  "colors.colorPalette.main": {
    "value": "var(--gHMSqG)",
    "variable": "var(--gHMSqG)"
  },
  "colors.colorPalette.dark": {
    "value": "var(--cLysdB)",
    "variable": "var(--cLysdB)"
  },
  "colors.colorPalette.darkest": {
    "value": "var(--iPnjZj)",
    "variable": "var(--iPnjZj)"
  },
  "colors.colorPalette.light": {
    "value": "var(--eQrkVj)",
    "variable": "var(--eQrkVj)"
  },
  "colors.colorPalette.light-2": {
    "value": "var(--kCAnZE)",
    "variable": "var(--kCAnZE)"
  },
  "colors.colorPalette.lighter": {
    "value": "var(--jxGibo)",
    "variable": "var(--jxGibo)"
  },
  "colors.colorPalette.lighter-2": {
    "value": "var(--cgLvyn)",
    "variable": "var(--cgLvyn)"
  },
  "colors.colorPalette.lightest": {
    "value": "var(--cKrWrJ)",
    "variable": "var(--cKrWrJ)"
  },
  "colors.colorPalette.extraLight": {
    "value": "var(--hQxAlZ)",
    "variable": "var(--hQxAlZ)"
  },
  "colors.colorPalette.tintLP": {
    "value": "var(--kDDVbm)",
    "variable": "var(--kDDVbm)"
  },
  "colors.colorPalette.darker": {
    "value": "var(--bHCqTC)",
    "variable": "var(--bHCqTC)"
  },
  "colors.colorPalette.lighter-3": {
    "value": "var(--kxQwK)",
    "variable": "var(--kxQwK)"
  },
  "colors.colorPalette.lighter-4": {
    "value": "var(--ckMXqR)",
    "variable": "var(--ckMXqR)"
  },
  "colors.colorPalette.tintLP2": {
    "value": "var(--ipZeZg)",
    "variable": "var(--ipZeZg)"
  },
  "colors.colorPalette.primary": {
    "value": "var(--gbCbhR)",
    "variable": "var(--gbCbhR)"
  },
  "colors.colorPalette.secondary": {
    "value": "var(--dDofdL)",
    "variable": "var(--dDofdL)"
  },
  "colors.colorPalette.default": {
    "value": "var(--bDjYrS)",
    "variable": "var(--bDjYrS)"
  },
  "colors.colorPalette.paper": {
    "value": "var(--eYETcL)",
    "variable": "var(--eYETcL)"
  },
  "colors.colorPalette.active": {
    "value": "var(--iaREDJ)",
    "variable": "var(--iaREDJ)"
  },
  "colors.colorPalette.hover": {
    "value": "var(--hjJRhX)",
    "variable": "var(--hjJRhX)"
  },
  "colors.colorPalette.disabled": {
    "value": "var(--gTYnIJ)",
    "variable": "var(--gTYnIJ)"
  },
  "colors.colorPalette.disabledBackground": {
    "value": "var(--gtnDcD)",
    "variable": "var(--gtnDcD)"
  },
  "colors.colorPalette.trim": {
    "value": "var(--gQVEmz)",
    "variable": "var(--gQVEmz)"
  },
  "colors.colorPalette.green": {
    "value": "var(--kSZRuW)",
    "variable": "var(--kSZRuW)"
  },
  "colors.colorPalette.greenDark": {
    "value": "var(--bOyNhW)",
    "variable": "var(--bOyNhW)"
  },
  "colors.colorPalette.greenLight": {
    "value": "var(--cTYxNs)",
    "variable": "var(--cTYxNs)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar